export default __webpack_public_path__ + "static/media/delete-icon.741c847d.svg";